const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://contactform-backend.bw-clinics.com/',
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL || 'https://id.bw-clinics.com',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'BWID',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'app-backend'
  }
};

export default config; 